module.exports = __webpack_public_path__ + "img/membership-2-desktop.6e4e5a03.png";